import { FC, useState } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Row, Column } from 'further-ui/components/Layout';
import DownloadFile from 'components/new/DownloadFile';
import { BulletinUpdateFormValues } from '../schema';

const ReviewButton = styled(Button)(({ theme }) => ({
  padding: 0,
  color: theme.palette.grey[600],
  textDecoration: 'underline',
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
  minWidth: 'auto',
}));

type Props = {
  attachments: BulletinUpdateFormValues['attachments'];
};

const Attachments: FC<Props> = ({ attachments }) => {
  const [displayAllAttachments, setDisplayAllAttachments] = useState(false);
  const attachmentCount = attachments.length;
  const isOnlyOne = attachmentCount === 1;
  const isMoreThanOne = attachmentCount > 1;

  return (
    <Column spacing="xs">
      {isMoreThanOne ? (
        <Row spacing="xs">
          <Typography variant="h6">{attachmentCount} files</Typography>
          <ReviewButton
            variant="text"
            color="primary"
            onClick={() => setDisplayAllAttachments(!displayAllAttachments)}
          >
            {displayAllAttachments ? 'Hide all' : 'Show all'}
          </ReviewButton>
        </Row>
      ) : null}
      {isOnlyOne || displayAllAttachments
        ? attachments.map((attachment) => (
            <DownloadFile key={attachment.path} file={attachment} />
          ))
        : null}
    </Column>
  );
};

export default Attachments;
